/** making equal height of an image and table element | table section */
const headings = document.querySelectorAll(".table-with-image .column-heading"); 
if(headings) { 
  headings.forEach(heading => {
    if(window.matchMedia('(min-width: 750px)').matches) { 
      const height = heading.offsetHeight;
      const parent = heading.closest(".table-with-image");
      const imageWrapper = parent.querySelector(".image-with-text__media-item");
      imageWrapper.style.marginTop = height + 'px';
    }
  });
}
